import { render } from "./GenericPage.vue?vue&type=template&id=1e2e0024&scoped=true&lang=pug"
import script from "./GenericPage.vue?vue&type=script&lang=ts"
export * from "./GenericPage.vue?vue&type=script&lang=ts"

import "./GenericPage.vue?vue&type=style&index=0&id=1e2e0024&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e2e0024"

export default script